export enum OrganizationTypeId {
    Salesforce = 1,
    Pardot = 2
}
